export const SYSTEM_DATE_PATTERN = 'MM/dd/y';
